import script from "./ProjectTaskLogPopover.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectTaskLogPopover.vue?vue&type=script&setup=true&lang=js"

import "./ProjectTaskLogPopover.vue?vue&type=style&index=0&id=2627f773&lang=css"
import "./ProjectTaskLogPopover.vue?vue&type=style&index=1&id=2627f773&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2627f773"]])

export default __exports__